// Render and validate mailing address fields
import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import Country from "./Country";
import Toggle from "./Toggle";

const MailingAddressFields = (props) => {
  const { watch, register, control, formState } = useFormContext();
  const watchSameAsBilling = watch("same_as_billing", false);
  return (
    <div className="component-mailing-address-fields">
      <h3>Mailing address</h3>
      {props.sameAsBillingOption && (
        <Controller
          control={control}
          name="same_as_billing"
          render={({ field: { value, onChange } }) => (
            <Toggle
              id="same_as_billing"
              value={value}
              onChange={onChange}
              label="Same as billing address"
            />
          )}
        />
      )}
      {!watchSameAsBilling && (
        <div id="mailing-address-fields">
          <div className="field">
            <input
              id="shipping_line1"
              type="text"
              placeholder=" "
              {...register("shipping_line1", {
                required: true,
              })}
              className={
                (formState.errors.shipping_line1 && "error") ||
                (formState.dirtyFields.shipping_line1 && "valid")
              }
            />
            <label htmlFor="shipping_line1">Address Line 1</label>
            <span className="field-error-msg">
              {formState?.errors?.shipping_line1?.type === "required" &&
                "Please enter your street address"}
            </span>
          </div>
          <div className="field">
            <input
              id="shipping_line2"
              type="text"
              placeholder=" "
              {...register("shipping_line2")}
              className={
                (formState.errors.shipping_line2 && "error") ||
                (formState.dirtyFields.shipping_line2 && "valid")
              }
            />
            <label htmlFor="shipping_line2">Address Line 2</label>
          </div>
          <div className="field">
            <input
              id="shipping_city"
              type="text"
              placeholder=" "
              {...register("shipping_city", {
                required: true,
              })}
              className={
                (formState.errors.shipping_city && "error") ||
                (formState.dirtyFields.shipping_city && "valid")
              }
            />
            <label htmlFor="shipping_city">City</label>
            <span className="field-error-msg">
              {formState?.errors?.shipping_city?.type === "required" &&
                "Please enter your city or town"}
            </span>
          </div>
          <div className="field">
            <input
              id="shipping_state"
              type="text"
              placeholder=" "
              {...register("shipping_state", {
                required: true,
              })}
              className={
                (formState.errors.shipping_state && "error") ||
                (formState.dirtyFields.shipping_state && "valid")
              }
            />
            <label htmlFor="shipping_state">State</label>
            <span className="field-error-msg">
              {formState?.errors?.shipping_state?.type === "required" &&
                "Please enter your state or province"}
            </span>
          </div>
          <div className="field">
            <input
              id="shipping_zip"
              type="text"
              placeholder=" "
              {...register("shipping_zip", {
                required: true,
              })}
              className={
                (formState.errors.shipping_zip && "error") ||
                (formState.dirtyFields.shipping_zip && "valid")
              }
            />
            <label htmlFor="shipping_zip">Postal Code</label>
            <span className="field-error-msg">
              {formState?.errors?.shipping_zip?.type === "required" &&
                "Please enter your postal code"}
            </span>
          </div>
          <div className="field">
            <Country name="shipping_country" />
          </div>
        </div>
      )}
    </div>
  );
};
export default MailingAddressFields;
